import { render, staticRenderFns } from "./ServiceTemplateList.html?vue&type=template&id=6567874e&scoped=true&external"
import script from "./ServiceTemplateList.js?vue&type=script&lang=js&external"
export * from "./ServiceTemplateList.js?vue&type=script&lang=js&external"
import style0 from "./ServiceTemplateList.scss?vue&type=style&index=0&id=6567874e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567874e",
  null
  
)

export default component.exports